import { FunctionComponent } from 'react';

type SearchIconProps = {
  width?: number | string;
  height?: number | string;
  active?: boolean;
  disable?: boolean;
};

const SearchIcon: FunctionComponent<SearchIconProps> = ({
  width = 34,
  height = 34,
  active = false,
  disable = false,
}) => {
  const circleFill = active ? '#561BDC' : disable ? '#D5D5D5' : '#FAFAFA';
  const strokeColor = active ? '#EDEDED' : disable ? '#8E8E8E' : '#1A1A1A';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 34 34"
    >
      <g transform="translate(-820 -962)">
        <circle
          cx="17"
          cy="17"
          r="17"
          transform="translate(820 962)"
          fill={circleFill}
        />
        <g transform="translate(11261 365)">
          <circle
            cx="6.444"
            cy="6.444"
            r="6.444"
            transform="translate(-10432 606)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1.2"
          />
          <line
            y2="6.444"
            transform="translate(-10420.557 617.443) rotate(-45)"
            fill="none"
            stroke={strokeColor}
            strokeLinecap="round"
            strokeWidth="1.2"
          />
        </g>
      </g>
    </svg>
  );
};

export default SearchIcon;
